// extracted by mini-css-extract-plugin
module.exports = {"contacts":"Contacts_contacts__1wYKH","block":"Contacts_block__1uVyn","content":"Contacts_content__1c-a0","info-block":"Contacts_info-block__37cBj"};